import { render, staticRenderFns } from "./WellnessSeries.vue?vue&type=template&id=f5807608"
import script from "./WellnessSeries.vue?vue&type=script&lang=js"
export * from "./WellnessSeries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports